import {
  normalizeWidgetConsentState,
  type WidgetConsentState,
} from './consentState';

export const CONSENT_STORAGE_KEY = 'passenger-widget-consent-state';

export function readStoredConsentState(): WidgetConsentState | null {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (raw === null) return null;
    const state = normalizeWidgetConsentState(raw);
    // prompt is the default/unset state — treat stored prompt as no stored value
    return state === 'prompt' ? null : state;
  } catch {
    return null;
  }
}

export function writeStoredConsentState(state: WidgetConsentState): void {
  try {
    if (state === 'prompt') {
      localStorage.removeItem(CONSENT_STORAGE_KEY);
    } else {
      localStorage.setItem(CONSENT_STORAGE_KEY, state);
    }
  } catch {
    // localStorage may be unavailable (private browsing, opaque origins, etc.)
  }
}

export function clearStoredConsentState(): void {
  try {
    localStorage.removeItem(CONSENT_STORAGE_KEY);
  } catch {
    // ignore
  }
}
